import Table from './Table';

export default Table;



// WEBPACK FOOTER //
// ./src/components/ui/Table/index.js